module.exports = __webpack_public_path__ + "static/media/return.289c3385.png";